import notFoundImg from '../assets/notFound.png';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 24 }}>
      <img src={notFoundImg} alt="Not Found" style={{ maxWidth: 300, marginBottom: 32 }} />
      <p style={{ fontWeight: 600, fontSize: 18 }}> This page does not exist</p>
      <p> Check the URL and try again</p>
    </div>
  );
} 